module.exports = __webpack_public_path__ + "images/backgrounds/river/small.6e029e790f7e349c1787.jpg";